import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Crown, Check } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { navigate("/dashboard"); return; }
    let cancelled = false;
    let count = 0;

    const poll = async () => {
      if (cancelled) return;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
        if (r.data.status === "expired") {
          setStatus("expired"); return;
        }
        count++;
        setAttempts(count);
        if (count >= 7) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6 dot-grid">
      <div className="card-brutal !p-10 max-w-md w-full text-center" data-testid="payment-status">
        {status === "checking" && (
          <>
            <div className="font-display font-black text-3xl mb-2">Confirming…</div>
            <p className="text-zinc-600">Verifying your payment ({attempts}/7)</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-14 h-14 mx-auto bg-[#FF4F00] border-2 border-black flex items-center justify-center mb-4"><Check className="text-white" size={28} /></div>
            <div className="font-display font-black text-3xl mb-2 flex items-center justify-center gap-2"><Crown size={24} className="text-[#FF4F00]" /> Welcome to Pro!</div>
            <p className="text-zinc-600 mb-6">Unlimited lead magnets unlocked. Time to ship.</p>
            <Link to="/dashboard" className="btn-brutal w-full" data-testid="goto-dashboard-btn">Go to Dashboard</Link>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <div className="font-display font-black text-3xl mb-2">Hmm…</div>
            <p className="text-zinc-600 mb-6">We couldn't confirm your payment yet. Please check back in a moment or contact support.</p>
            <Link to="/pricing" className="btn-brutal-outline w-full">Back to Pricing</Link>
          </>
        )}
      </div>
    </div>
  );
}
